import { z } from 'zod'

export const schema = z.object({
  closedDates: z.array(z.string()),
})

export type schemaType = z.infer<typeof schema>

export const paramsSchema = z.object({
  id: z.string().min(1),
})

export type paramsType = z.infer<typeof paramsSchema>

export type returnType = ApiServerResponse<schemaType>
